<template>
  <IconLucideArrowRight />
</template>
